import BaseService from './BaseService'

class CompanyService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }
  read = (id: string) =>
    this.requests.get(`/${id}`)
  update = (id: string, data: { [key: string]: any }) =>
    this.requests.put(`/${id}`, data)
  Lab = {
    addFeedback: (companyId: string, body: { [key: string]: any }) =>
      this.requests.post(`/${companyId}/labs/feedbacks`, body),
    getFeatureFlags: (companyId: string) =>
      this.requests.get(`/${companyId}/labs/featureFlags`),
    upsertFeatureFlag: (companyId: string, body: { [key: string]: any }) =>
      this.requests.put(`/${companyId}/labs/featureFlags`, body),
  }
}

const instance = new CompanyService(BaseService.servicesConfig.Companies)

export default instance
